export default __webpack_public_path__ + "082b8317160447fb78309156fec28320.svg";